
export default {
    box_shadow: 'inset 0px 5px 6px -3px rgba(0, 0, 0, 0.4)',
    box_shadow_height: 6
};
